// src/layouts/EscolaLegislativoLayout.tsx
import * as React from 'react';
import { Box, Divider, Paper, Typography, useMediaQuery, useTheme } from '@mui/material';

import { A11ySkipLink } from '../site/A11ySkipLink';
import { A11yToolbar } from '../site/A11yToolbar';
import { HeaderSiteRedeSocial } from '../../menuSite/HeaderSiteRedeSocial';
import { HeaderSiteLogo } from '../site/HeaderSiteLogo';
import { HeaderSiteMenu } from '../../menuSite/HeaderSiteMenu';
import { HeaderEscolaLegislativoLogo } from './HeaderEscolaLegislativoLogo';
import { HeaderEscolaLegislativoMenu } from '../../menuSite/HeaderEscolaLegislativoMenu';

export function EscolaLegislativoLayout({ children }: { children: React.ReactNode }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  //carregar o theme com base no slice

  return (
    <Box
      id="container-main"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        minHeight: '100vh',
        width: '100%',
        padding: 0,
        backgroundColor: theme.palette.background.default,
        fontFamily: theme.typography.fontFamily
      }}
    >
      {/*Esse componente A11ySkipLink é um link de acessibilidade (skip link), uma prática importante para tornar seu site mais acessível a pessoas que usam leitores de tela ou navegam por teclado. */}
      <A11ySkipLink />
      {/*Esse componente A11yToolbar é uma barra de ferramentas de acessibilidade que oferece várias funcionalidades para melhorar a experiência do usuário, especialmente para aqueles com necessidades especiais. */}
      <A11yToolbar />

      <Box
        id="container-header"
        sx={{
          display: 'flex',
          flexDirection: 'column',
          width: {
            xs: '100%',
            sm: '60%'
          },
          padding: 0
        }}
      >
        {!isMobile && (
          <Box id="header-rede-social" sx={{ width: '100%' }}>
            <HeaderSiteRedeSocial />
          </Box>
        )}

        <Box id="header-site-logo">
          <HeaderEscolaLegislativoLogo />
        </Box>

        <Box id="header-site-menu" sx={{ width: '100%' }}>
          <HeaderEscolaLegislativoMenu />
        </Box>
      </Box>

      <Box sx={{ width: '100%' }}>
        <Divider
          orientation="horizontal"
          sx={{
            borderColor: theme.palette.divider || '#EBEBEB',
            borderBottomWidth: 5
          }}
        />
      </Box>

      <Box
        id="container-content"
        sx={{
          display: 'flex',
          flexDirection: 'column',
          width: {
            xs: '100%',
            sm: '60%'
          },
          minHeight: '100vh',
          padding: 0
        }}
      >
        <Paper
          elevation={2}
          sx={{
            flex: 1,
            padding: 2,
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'top',
            backgroundColor: theme.palette.background.paper
          }}
        >
          {children}
        </Paper>
      </Box>
    </Box>
  );
}
